// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-modal_default__2smdz","active":"idt-modal_active__266nt","overlay":"idt-modal_overlay__k4kzc","container":"idt-modal_container__31srn"};